module.exports = __webpack_public_path__ + "static/media/yves-saint-laurent-black-opium-big.0d3c0ea9.png";